import { isExistent } from "src/utils/miscellaneous";

export interface VersionInfo {
  build: string | null;
  version: string;
}

export function getBuildIdentifier({
  build,
  environment,
  version,
}: VersionInfo & { environment: string }): string {
  const buildDetails = [build || "0", environment];
  return `${version}+${buildDetails.filter(isExistent).join(".")}`;
}
